import axios from 'axios';

// 第一个代理基础路径配置


// 第二个代理基础路径配置
export const instance = axios.create({
    baseURL:'/manual'
});
// instance.defaults.timeout = 20000;
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

export default axios;


// WEBPACK FOOTER //
// ./src/components/axios/auth.js